/**
 * Utility functions for debugging
 */

/**
 * Logs detailed information about cricket scores to help debug rendering issues
 * @param cricketScores The cricket scores array from the event
 * @param componentName The name of the component doing the logging
 */
export const debugCricketScores = (cricketScores: any, componentName: string): void => {
  console.group(`Cricket Scores Debug [${componentName}]`);
  console.log('Cricket scores array:', cricketScores);
  
  if (!cricketScores) {
    console.log('Cricket scores is undefined or null');
  } else if (!Array.isArray(cricketScores)) {
    console.log('Cricket scores is not an array:', typeof cricketScores);
  } else if (cricketScores.length === 0) {
    console.log('Cricket scores array is empty');
  } else {
    console.log('Number of scores:', cricketScores.length);
    console.log('First score:', cricketScores[0]);
    
    // Check for required properties
    const firstScore = cricketScores[0];
    const missingProps = [];
    
    if (firstScore.sequenceId === undefined) missingProps.push('sequenceId');
    if (firstScore.timestamp === undefined) missingProps.push('timestamp');
    if (firstScore.ballReference === undefined) missingProps.push('ballReference');
    if (firstScore.runs === undefined) missingProps.push('runs');
    if (firstScore.isWicket === undefined) missingProps.push('isWicket');
    if (firstScore.firstTeamScore === undefined) missingProps.push('firstTeamScore');
    if (firstScore.secondTeamScore === undefined) missingProps.push('secondTeamScore');
    
    if (missingProps.length > 0) {
      console.warn('Missing properties in cricket score:', missingProps);
    }
    
    // Check team scores
    if (firstScore.firstTeamScore) {
      const teamMissingProps = [];
      if (firstScore.firstTeamScore.runs === undefined) teamMissingProps.push('runs');
      if (firstScore.firstTeamScore.wickets === undefined) teamMissingProps.push('wickets');
      if (firstScore.firstTeamScore.isBatting === undefined) teamMissingProps.push('isBatting');
      
      if (teamMissingProps.length > 0) {
        console.warn('Missing properties in firstTeamScore:', teamMissingProps);
      }
    }
    
    if (firstScore.secondTeamScore) {
      const teamMissingProps = [];
      if (firstScore.secondTeamScore.runs === undefined) teamMissingProps.push('runs');
      if (firstScore.secondTeamScore.wickets === undefined) teamMissingProps.push('wickets');
      if (firstScore.secondTeamScore.isBatting === undefined) teamMissingProps.push('isBatting');

      if (teamMissingProps.length > 0) {
        console.warn('Missing properties in secondTeamScore:', teamMissingProps);
      }
    }
  }
  console.groupEnd();
};

/**
 * Logs detailed information about table tennis scores to help debug rendering issues
 * @param ttScores The table tennis scores array from the event
 * @param componentName The name of the component doing the logging
 */
export const debugTtScores = (ttScores: any, componentName: string): void => {
  console.group(`TT Scores Debug [${componentName}]`);
  console.log('TT scores array:', ttScores);

  if (!ttScores) {
    console.log('TT scores is undefined or null');
  } else if (!Array.isArray(ttScores)) {
    console.log('TT scores is not an array:', typeof ttScores);
  } else if (ttScores.length === 0) {
    console.log('TT scores array is empty');
  } else {
    console.log('Number of scores:', ttScores.length);
    console.log('First score:', ttScores[0]);

    const firstScore = ttScores[0];
    const missingProps = [];
    if (firstScore.sequenceId === undefined) missingProps.push('sequenceId');
    if (firstScore.timestamp === undefined) missingProps.push('timestamp');
    if (firstScore.currentSet === undefined) missingProps.push('currentSet');
    if (firstScore.players === undefined) missingProps.push('players');

    if (missingProps.length > 0) {
      console.warn('Missing properties in TT score:', missingProps);
    }
  }
  console.groupEnd();
};
